import React, { useEffect, useState } from 'react'
import { RiskHorizontalDisplay } from '../../components/Common'
import RiskActionDetails from '../../components/RiskActionDetails'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import moment from 'moment'
import utils from '../../utils'

const RiskPdf3 = props => {
  const {
    dataActions,
    type,
    riskStore,
    departmentStore,
    selectPeopleStore,
  } = props
  const { departmentList } = departmentStore
  const { riskUnitsV2 } = riskStore
  const riskDetail = toJS(props.riskDetail)
  let doi_tuong_thuc_hien = {}
  if (dataActions?.tier1?.length > 0) {
    doi_tuong_thuc_hien = dataActions?.tier1[0]?.doi_tuong_thuc_hien
  }
  const department_name_nddpv_cua_vimc_tai_dntv =
    Array.isArray(riskUnitsV2) &&
    riskUnitsV2?.find(
      e =>
        e.code === doi_tuong_thuc_hien?.department_code_nddpv_cua_vimc_tai_dntv
    )
  const department_name_DVPY_cua_VIMC =
    Array.isArray(riskUnitsV2) &&
    riskUnitsV2?.find(e => e.code === doi_tuong_thuc_hien?.dvpt_cua_vimc)

  const findDepartmentByCode = unit_code => {
    return departmentList?.find(dept => dept.code === unit_code)
  }

  const [departmentWithUserList, setDepartmentWithUserList] = useState([])
  useEffect(() => {
    selectPeopleStore
      .getDepartmentWithUsersLive('CPN7451091748209')
      .then(res => {
        setDepartmentWithUserList(res.data)
      })
  }, [])

  return (
    <div id={'riskDivToPrint'} style={{ fontSize: '10px !important ' }}>
      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div
                style={{
                  textAlign: 'center',
                }}>
                <img
                  id="logo"
                  style={{ width: '130px' }}
                  src={`${window.location.protocol}//${window.location.host}/assets/photos/portal_logo_blue.png`}
                />
                <div
                  style={{
                    borderRight: '1px solid black',
                    height: '30px',
                    margin: '20px 0',
                    padding: '10px 0',
                  }}></div>
              </div>
            ),
            style: {
              margin: 0,
              border: '1px solid white',
            },
          },
          //     {
          //       image: (
          //         <div
          //           style={{
          //             borderLeft: '1px solid black',
          //             height: '30px',
          //             margin: '20px 0',
          //             padding: '10px 0',
          //           }}></div>
          //       ),
          //       style: {
          //         margin: 0,
          //       },
          //     },
          {
            value: (
              <div
                style={{
                  margin: 0,
                  padding: 0,
                  fontSize: '20px',
                }}>
                <div style={{ textAlign: 'center', margin: 0 }}>
                  CÔNG TY CỔ PHẦN
                </div>
                <div style={{ textAlign: 'center', margin: 0 }}>
                  ĐẠI LÝ HÀNG HẢI
                </div>
                <div style={{ textAlign: 'center', margin: 0 }}>VIỆT NAM</div>
              </div>
            ),
            style: {
              margin: '40px 20px 40px 10px',
              border: '1px solid white',
            },
          },
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <h3 style={{ marginBottom: 10 }}>KIỂM SOÁT RỦI RO</h3>
                <div style={{ fontSize: 18 }}>
                  Số:
                  {riskDetail.risk_index < 10
                    ? `0${riskDetail.risk_index}`
                    : riskDetail.risk_index?.toString()}{' '}
                  Ngày {moment(riskDetail.created_at).format('DD/MM/YYYY')}
                </div>
              </div>
            ),
            style: {
              margin: '40px 10px 40px 20px',
              border: '1px solid white',
            },
          },
        ]}
        tableStyle={{ margin: 0 }}
      />

      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <h4>BA TUYẾN PHÒNG VỆ</h4>
              </div>
            ),
            style: { margin: '10px 10px', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 20px 200px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                {' '}
                <h5>
                  {utils.checkRichType(
                    type,

                    <span>
                      {utils.getNameInCapitalize(
                        department_name_nddpv_cua_vimc_tai_dntv?.name
                      )}
                    </span>,
                    <span>
                      {utils.getNameInCapitalize(
                        department_name_DVPY_cua_VIMC?.name
                      )}
                    </span>,
                    <span>
                      {
                        findDepartmentByCode(
                          doi_tuong_thuc_hien?.cac_don_vi_thuoc_cq_vp_cua_vimc
                        )?.name
                      }
                    </span>
                  )}
                </h5>
                <h5>A. Tuyến phòng vệ thứ nhất</h5>
                <RiskActionDetails
                  type={type}
                  data={dataActions?.tier1}
                  riskUnitsV2={riskUnitsV2}
                  tier={'1'}
                  isPartOfPdf
                  departmentWithUserMasterList={departmentWithUserList}
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              //   border: '1px solid black',
              borderTop: '1px solid black',
              borderRight: '1px solid black',
              borderLeft: '1px solid black',
              borderBottom: '1px solid black',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: 0, width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <h5 style={{ marginTop: 16 }}>B. Tuyến phòng vệ thứ hai</h5>
                <RiskActionDetails
                  type={type}
                  data={dataActions?.tier2}
                  tier={'2'}
                  isPartOfPdf
                  departmentWithUserMasterList={departmentWithUserList}
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              borderTop: '1px solid black',
              borderRight: '1px solid black',
              borderLeft: '1px solid black',
              borderBottom: '1px solid black',
              margin: '0 10px',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            },
          },
        ]}
        tableStyle={{ margin: 0, width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <h5 style={{ marginTop: 16 }}>C. Tuyến phòng vệ thứ ba</h5>
                <RiskActionDetails
                  data={dataActions?.tier3}
                  tier={'3'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              //   border: '1px solid black',
              borderTop: '1px solid black',
              borderRight: '1px solid black',
              borderLeft: '1px solid black',
              borderBottom: '1px solid black',
              margin: '0 10px',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            },
          },
        ]}
        tableStyle={{ margin: 0, width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <>
                <RiskActionDetails
                  data={dataActions?.tier4}
                  tier={'4'}
                  isPartOfPdf
                />
              </>
            ),
            style: {
              textAlign: 'flex',
              //   border: '1px solid black',
              borderTop: '1px solid black',
              borderRight: '1px solid black',
              borderLeft: '1px solid black',
              borderBottom: '1px solid black',
              margin: '0 10px',
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            },
          },
        ]}
        tableStyle={{ margin: 0, width: '100%' }}
      />
    </div>
  )
}
RiskPdf3.propTypes = {}

export default inject(
  'riskStore',
  'departmentStore',
  'selectPeopleStore'
)(observer(RiskPdf3))
